import Action from './action';

const initialState = {
    phoneNumberCompletion: [],
    errorText: '',
};

export default (state = initialState, action: {type: string, playload: string[] | string}) => {
    switch (action.type) {
        case Action.UPDATE_PHONE_NUMBER_COMPLETION: {
            return {
                ...state,
                phoneNumberCompletion: action.playload
            }
        }
        case Action.UPDATE_PHONE_NUMBER_COMPLETION_ERROR_TEXT: {
            return {
                ...state,
                errorText: action.playload
            }
        }
        default: return state;
    }
}
